/**
 * Created by Daniel on 5/4/17.
 */

import React, { Component } from "react";
import EditAddDevicesToTest from "../presentation/EditAddDevicesToTest";

class EditAddDevicesToTestWidget extends Component {
  constructor(props) {
    super(props);

    this.state = {
      devices: [],
      clusters: [],
      selectedDevices: [],
      clusterName: "",
      clusterComments: "",
      errorField: "",
      success: "",
      error: "",
      clusterDevices: [],
      testInstanceDevices: this.props.getTestInstanceDevices,
      search: "",
      testInstanceId: this.props.pageParameters[0]
    };
  }

  componentDidMount() {
    this.getDeviceList();
  }

  updateDeviceList = deviceId => {
    let selectedDevice = this.state.devices.find(device => {
      return device._id === deviceId;
    });
    let devices = this.state.devices;
    devices.splice(devices.indexOf(selectedDevice), 1);
    let selectedDevices = this.state.selectedDevices;
    selectedDevices.push(selectedDevice);
    this.setState({ selectedDevices: selectedDevices, devices: devices });
  };

  removeDevice = deviceId => {
    let device = this.state.selectedDevices.find(selectedDevice => {
      return selectedDevice._id === deviceId;
    });
    let selectedDevices = this.state.selectedDevices;
    selectedDevices.splice(selectedDevices.indexOf(device), 1);
    let devices = this.state.devices;
    devices.push(device);
    this.setState({ selectedDevices: selectedDevices, devices: devices });
  };

  mergeToSelectedDevices = devices => {
    let selectedDevices = this.state.selectedDevices;
    let result = "";
    devices.map(device => {
      result = this.state.selectedDevices.find(
        selectedDevice => selectedDevice._id === device._id
      );

      if (result == null) {
        selectedDevices.push(device);
      }
    });

    this.setState({ selectedDevices });
  };

  removeClusterDevice = deviceId => {
    let device = this.state.selectedDevices.find(selectedDevice => {
      return selectedDevice._id === deviceId;
    });
    let selectedDevices = this.state.selectedDevices;
    selectedDevices.splice(selectedDevices.indexOf(device), 1);
    this.setState({ selectedDevices: selectedDevices });
  };

  getDeviceList = () => {
    fetch("/service/devices?search=" + this.state.search, {
      method: "GET",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json"
      },
      credentials: "same-origin"
    }).then(response => {
      if (response.status !== 200) {
        this.setState({
          serverError:
            "Please add devices from the Device Management section to display."
        });
      } else {
        response.json().then(json => {
          let devices = json;
          let selectedDevices = this.state.selectedDevices;
          let testInstanceDevices = this.state.testInstanceDevices;
          if (selectedDevices.length) {
            let result = "";

            selectedDevices.map(selectedDevice => {
              result = devices.find(
                device => device._id === selectedDevice._id
              );

              if (result) {
                devices.splice(devices.indexOf(result), 1);
              }
            });
          } else {
            if (testInstanceDevices.length) {
              let result = "";
              let selectedDevices = [];

              testInstanceDevices.map(testInstanceDevice => {
                result = devices.find(
                  device => device._id === testInstanceDevice._id
                );

                if (result) {
                  devices.splice(devices.indexOf(result), 1);
                  selectedDevices.push(result);
                }
              });

              this.setState({ selectedDevices });
            }
          }
          this.setState({ devices: devices, clusters: "", clusterDevices: "" });
        });
      }
    });
  };

  getClusters = () => {
    fetch("/service/clusters", {
      method: "GET",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json"
      },
      credentials: "same-origin"
    }).then(response => {
      if (response.status !== 200) {
        response.json().then(json => {
          this.setState({
            serverError:
              "Please add clusters from the Device Management section to display."
          });
        });
      } else {
        response.json().then(clusters => {
          this.setState({ clusters });
        });
      }
    });
  };

  getClusterDevices(cluster, e) {
    let devices = cluster.devices;
    this.setState({
      clusterName: cluster.name,
      clusterComments: cluster.comments
    });

    if (e.target.checked) {
      fetch("/service/getClusterDevices?devices=" + devices, {
        method: "GET",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json"
        },
        credentials: "same-origin"
      }).then(response => {
        if (response.status === 200) {
          response.json().then(clusterDevices => {
            this.setState({ clusterDevices });
            this.mergeToSelectedDevices(clusterDevices);
          });
        }
      });
    } else {
      cluster.devices.map(device => {
        this.removeClusterDevice(device);
      });
    }
  }

  handleSave = () => {
    let selectedDevices = this.state.selectedDevices;
    this.props.navigator.requestEditTestInstance(this.state.testInstanceId);
    this.props.updateTestDevices(selectedDevices);
  };

  updateSearchState = e => {
    this.setState({ search: e.target.value }, () => {
      this.getDeviceList();
    });
  };

  goBack = () => {
    this.props.navigator.requestEditTestInstance(this.state.testInstanceId);
  };

  render() {
    return (
      <EditAddDevicesToTest
        navigator={this.props.navigator}
        loadData={this.state}
        updateDeviceList={this.updateDeviceList}
        removeDevice={this.removeDevice}
        updateSearchState={this.updateSearchState}
        getClusters={this.getClusters}
        getDevices={this.getDeviceList}
        getClusterDevices={this.getClusterDevices}
        handleSave={this.handleSave}
        goBack={this.goBack}
      />
    ); //return
  } //render
} //EditAddDevicesToTestWidget

export default EditAddDevicesToTestWidget;
